import { UNGROUPED_PERMISSION_AREA } from '../constants/permissions'

export type DomainArea<T> = { area: string; domains: T[] }

// Groups authorisation domains by their area (domains without one go under "Other"), sorted by
// area name, so every domain picker/list presents them the same way.
export const groupDomainsByArea = <T extends { area?: string }>(
  domains: T[]
): DomainArea<T>[] => {
  const domainsByArea = new Map<string, T[]>()

  domains.forEach((domain) => {
    const area = domain.area || UNGROUPED_PERMISSION_AREA
    const existing = domainsByArea.get(area)

    if (existing) {
      existing.push(domain)
    } else {
      domainsByArea.set(area, [domain])
    }
  })

  return [...domainsByArea.entries()]
    .map(([area, areaDomains]) => ({ area, domains: areaDomains }))
    .sort((a, b) => a.area.localeCompare(b.area))
}
